import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useQuery } from "react-query";

export function useIsExpertOrGreater(customerId: number, substationId?: number, substationName?: string) {
  const apiContext = useContext(ApiContext);
  return useQuery({
    queryKey: ["isExpertOrGreater", customerId, substationId, substationName],
    queryFn: async () => {
      if (substationId || substationName)
        return await apiContext.accessControlApis.isExpertOrGreater(customerId, substationId, substationName);
    },
  });
}
